/**
 * Feedback service
 */

import { apiClient } from './api';

export interface FeedbackPayload {
  area: string;
  notes: string;
  blocks_progress?: boolean;
  severity?: 'low' | 'medium' | 'high';
  route?: string;
  lab_id?: number;
  lab_slug?: string;
  run_id?: number;
  client_last_error?: string;
  frontend_version?: string;
}

export async function submitFeedback(data: FeedbackPayload): Promise<{ message: string; id: string }> {
  return apiClient.post('/feedback/', data);
}
